import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"
import { RoleDTO } from "../components/screens/employees/positions/types"

export const getRoleApi = (headers: Record<string, any>): Rx.Observable<RoleDTO[]> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: "/role",
            headers: headers,
        })
    ).pipe(retry(2))
